import { Injectable } from "@angular/core";
import { OperatorType, OrderBy, Query } from "ngx-odata-v4";
import { SearchResponse } from "../objects/responses/searchResponse";
import { OrderSearchRequest } from "../objects/requests/orderSearchRequest";
import { Http, RequestOptions } from "@angular/http";
import { Order } from "../objects/orders/order";
import { BaseResponse } from "../objects/common/baseResponse";
import { ConfigService } from "./configService";
import { User } from "../objects/users/user";


@Injectable()
export class OrderODataService {

    constructor(private http: Http, private config: ConfigService) {

    }

    public search(request: OrderSearchRequest): Promise<SearchResponse<Order>> {
        const query = this.createQuery(request.Skip, request.Top, request.OrderBy);

        if(request.Query){
            query.filterComplex(`contains(Customer/Email, '${request.Query}') 
            or contains(Customer/FirstName, '${request.Query}') 
            or contains(Customer/LastName, '${request.Query}') 
            or contains(Customer/Company/Name, '${request.Query}') 
            or startswith(cast(Id, 'Edm.String'),'${request.Query}')
            or contains(concat(concat(Customer/FirstName, ' '), Customer/LastName), '${request.Query}' )
            `);
        }

        return this.http.get(`${this.config.config.ApiUrl}/OrderOData?${query.compile()}`).toPromise().then((x: any) => {
            const result = x.json();
            return new SearchResponse<Order>({
                Items: result.value,
                TotalCount: result['@odata.count']
            })
        });
    }

    private expandAll(query: any) {
        query.expand("OrderItems", (oi: any) =>
            oi.expand("CanadianCurrencyCode"))
            .expand("Agent", (agent: any) => {
                agent.select("FullName", "Email")
            })
            .expand("Locations")
            .expand("Currency")
            .expand("Customer", (cust: any) =>
                cust.expand("Company")
            ).expand("Totals");
    }

    private createQuery(skip: number, top: number, orderBy: {PropertyName: string, OrderBy: OrderBy} = null) : any{
        const query = Query.create().count(true);

        if (orderBy && orderBy.PropertyName != "''")
            query.orderByComplex(`${orderBy.PropertyName.split('.').join('/')} ${orderBy.OrderBy}`);

        query.skip(skip).top(top);

        this.expandAll(query);

        return query;
    }

    public getOrdersByAgentId(agentId: number, skip: number, top: number, orderBy: any = null): Promise<SearchResponse<Order>>  {
        const query = this.createQuery(skip, top, orderBy);

        query.filterComplex(`AgentId eq ${agentId}`);

        return this.http.get(`${this.config.config.ApiUrl}/OrderOData?${query.compile()}`).toPromise().then((x: any) => {
            const result = x.json();
            return new SearchResponse<Order>({
                Items: result.value,
                TotalCount: result['@odata.count']
            })
        });
    }

    public getByCustomerId(customerId: number, skip: number, top: number, orderBy: any = null): Promise<SearchResponse<Order>>  {
        const query = this.createQuery(skip, top, orderBy);

        query.filterComplex(`Customer/OriginalId eq ${customerId}`);

        return this.http.get(`${this.config.config.ApiUrl}/OrderOData?${query.compile()}`).toPromise().then((x: any) => {
            const result = x.json();
            return new SearchResponse<Order>({
                Items: result.value,
                TotalCount: result['@odata.count']
            })
        });
    }
}


// WEBPACK FOOTER //
// ./app/services/orderOData.service.ts